import { render, staticRenderFns } from "./AppHeaderNavLinksItem.vue?vue&type=template&id=4425ef77&"
import script from "./AppHeaderNavLinksItem.vue?vue&type=script&lang=js&"
export * from "./AppHeaderNavLinksItem.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderNavLinksItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports